import React from "react"
import ReactNative from "react-native"

import { connect } from "react-redux"
import Device from "app/lib/Device"
import FS from "app/components/FS"

import AnimatedIconJumble from "app/components/AnimatedIconJumble"

import * as Animatable from "react-native-animatable"

import { colors } from "app/lib/styles"

const { StatusBar, View, StyleSheet, TouchableWithoutFeedback } = ReactNative

class SubscriptionSuccessAnimation extends React.Component {
  state = {}

  constructor(props) {
    super(props)
  }

  get sub() {
    var id = this.props.challenges.latestChallengeSubscriptionId
    if (id) {
      return dataStore.get("challenge_subscription", id)
    }
    return null
  }

  onJumbleDone = () => {
    this.props.onCompletion()
  }

  render() {
    return (
      <View style={styles.container}>
        <StatusBar hidden />
        <AnimatedIconJumble
          style={styles.jumble}
          onAnimationCompleted={this.onJumbleDone}
        />
      </View>
    )
    /*
        <Animatable.View animation="pulse" delay={600}>
          <FS.Text style={styles.successText}>{this.props.successText || "SUCCESS!"}</FS.Text>
          <FS.Text style={[styles.successText, styles.successSubtext]}>You successfully completed {this.sub.challenge_difficulty.displayName}</FS.Text>
        </Animatable.View>
*/
  }
}

function mapStateToProps(state) {
  return Object.assign(
    {},
    {
      challenges: state.challenges,
      checkins: state.checkins,
    }
  )
}

export default connect(mapStateToProps)(SubscriptionSuccessAnimation)

var styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  jumble: {
    position: "absolute",
    top: -20,
    left: 0,
    right: 0,
    bottom: 0,
  },
  successText: {
    fontSize: 40,
    fontWeight: "600",
    textAlign: "center",
    color: colors.white,
    backgroundColor: "transparent",
    textShadowRadius: 8,
    textShadowColor: "rgba(0,0,0,0.3)",
    textShadowOffset: {
      width: 0.2,
      height: 0.2,
    },
  },
  successSubtext: {
    fontSize: 16,
    fontWeight: "500",
    marginTop: 5,
  },
})
